<template>
  <div id="page-vessel-list">
    <div class="vx-card p-6 card-vessel-list">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  totalVessel - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : totalVessel
                }}
                / {{ totalVessel }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="onChangePageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="onChangePageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-button
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          icon-pack="feather"
          icon="icon-list"
          color="success"
          :to="{
            name: 'enterprise-management-vessel-sort',
          }"
          >表示順序を変更する</vs-button
        >
        <vs-button
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          icon-pack="feather"
          icon="icon-search"
          color="primary"
          type="border"
          @click="showDialogSearchCondition"
          >検索条件を変更する</vs-button
        >
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="dispVessels"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :suppressDragLeaveHidesColumns="true"
        :enableRtl="$vs.rtl"
        @rowClicked="rowClicked"
        @dragStopped="onDragStopped"
      >
      </ag-grid-vue>

      <vs-pagination
        v-if="isReadyPagination"
        :total="totalPages"
        :max="7"
        v-model="currentPage"
      />
    </div>
    <dialog-vessel-search-condition
      :searchCondition.sync="searchCondition"
      ref="dialogVesselSearchCondition"
      @searchVessels="onSearchVessels"
    ></dialog-vessel-search-condition>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererVesselCategory from "./cell-renderer/CellRendererVesselCategory.vue";
import CellRendererCountryFlags from "./cell-renderer/CellRendererCountryFlags";
import { VesselMixin } from "@/mixins";
import DialogVesselSearchCondition from "@/components/dialogs/DialogVesselSearchCondition";
import FireStoreService from "@/services/fireStoreService";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "enterpriseVesselList"
);

const INITIAL_PAGE_SIZE = 10;

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererVesselCategory,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererStatus,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererVerified,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererActions,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererCountryFlags,
    DialogVesselSearchCondition,
  },
  mixins: [VesselMixin],
  data() {
    return {
      vesselData: null,
      searchCondition: {
        name: "",
        isDisabled: "enable",
        isDeleted: false,
        page: this.getCurrentPage(),
        limit: INITIAL_PAGE_SIZE,
      },
      currentPage: 1,
      searchQuery: "",
      searchName: "",
      isReadyPagination: false,
      prevRoute: null,

      // AgGrid
      gridApi: null,
      gridOptions: {
        localeText: { noRowsToShow: "船舶が見つかりませんでした" },
        context: {
          componentParent: this,
        },
      },
      pageSize: INITIAL_PAGE_SIZE,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: null,
      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    };
  },
  watch: {
    currentPage() {
      FireStoreService.setAccountSetting("vessel_list", {
        current_page: this.currentPage,
      });
      this.searchVessels();
    },
  },
  computed: {
    ...mapState({
      vessels: state => state.vessels,
      pageable: state => state.pageable,
      countryCodes: state => state.countryCodes,
    }),

    dispVessels() {
      return JSON.parse(JSON.stringify(this.vessels)).map(vessel => {
        vessel.name = vessel.name_ja || vessel.name;
        return vessel;
      });
    },
    paginationPageSize() {
      return this.pageSize;
    },

    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },

    totalVessel() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },
  },
  methods: {
    ...mapActions([
      "fetchVessels",
      "fetchCountryCode",
      "resetVesselsListState",
    ]),

    setPageSize(size) {
      this.pageSize = size;
      FireStoreService.setAccountSetting("vessel_list", {
        page_size: this.pageSize,
      });
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },

    restoreSearchCondition(vesselListSetting) {
      const prevRouteName =
        this.prevRoute && this.prevRoute.name ? this.prevRoute.name : "";

      if (!prevRouteName.startsWith("enterprise-management-vessel-")) {
        // 船舶管理以外から来た場合は１ページ目から
        this.currentPage = 1;
      } else if (prevRouteName.endsWith("-sort")) {
        // 表示順序変更は１ページ目から
        this.currentPage = 1;
      } else {
        // 上記以外の船舶管理画面からの遷移は、ページ番号等をリストア
        const searchCondition =
          vesselListSetting && vesselListSetting.search_condition
            ? vesselListSetting.search_condition
            : {};
        this.searchCondition = {
          ...this.searchCondition,
          name: searchCondition.name || "",
          isDisabled: searchCondition.is_disabled || "enable",
          isDeleted: searchCondition.is_deleted || false,
        };
        this.currentPage =
          vesselListSetting && vesselListSetting.current_page
            ? vesselListSetting.current_page
            : 1;
      }

      // currentPage は vs-pagination がロードされる前に初期値をセットしておく。
      this.isReadyPagination = true;
    },

    rowClicked(evt) {
      this.$router.push({
        name: "enterprise-management-vessel-view",
        params: { vesselId: evt.data.id },
      });
    },

    onDragStopped(e) {
      const vesselListOrder =
        e.columnApi.getAllGridColumns().map(x => x.colId) || [];
      FireStoreService.setAccountSetting("vessel_list", {
        columns: vesselListOrder,
      });
    },

    showDialogSearchCondition() {
      this.$refs.dialogVesselSearchCondition.show();
    },

    onChangePageSize(size) {
      this.setPageSize(size);
      this.currentPage = 1;
      this.searchVessels();
    },

    onSearchVessels() {
      FireStoreService.setAccountSetting("vessel_list", {
        search_condition: {
          name: this.searchCondition.name || "",
          is_disabled: this.searchCondition.isDisabled || "enable",
          is_deleted: this.searchCondition.isDeleted || false,
        },
      });
      this.currentPage = 1;
      this.searchVessels();
    },

    async searchVessels() {
      let payload = {
        name: this.searchCondition.name,
        is_disabled: this.getDisabled(),
        is_deleted: false,
        page: this.getCurrentPage(),
        limit: this.pageSize,
      };
      this.$vs.loading();
      try {
        await this.fetchVessels(payload);
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
    getDisabled() {
      if (this.searchCondition.isDisabled === "all") {
        return "";
      }
      if (this.searchCondition.isDisabled === "enable") {
        return false;
      }
      if (this.searchCondition.isDisabled === "disabled") {
        return true;
      }
    },
    cleanup() {
      this.resetVesselsListState();
    },
  },
  async beforeMount() {
    const initialColumnDefs = [
      {
        headerName: "船舶ステータス",
        field: "status",
        width: 150,
        cellRendererFramework: "CellRendererStatus",
      },
      {
        headerName: "船名",
        field: "name",
        width: 250,
      },
      {
        headerName: "船種",
        field: "vessel_category.id",
        width: 150,
        cellRendererFramework: "CellRendererVesselCategory",
      },
      {
        headerName: "国籍",
        field: "country_code.id",
        width: 150,
        cellRendererFramework: "CellRendererCountryFlags",
      },
      {
        headerName: "MMSI番号",
        field: "mmsi",
        width: 150,
      },
      {
        headerName: "IMO番号",
        field: "imo",
        width: 150,
      },
      {
        headerName: "コールサイン",
        field: "call_sign",
        width: 150,
      },
    ];
    let columnDefs = [];
    const vesselListSetting = await FireStoreService.getAccountSetting(
      "vessel_list"
    );
    if (
      vesselListSetting &&
      vesselListSetting.columns &&
      vesselListSetting.columns.length > 0
    ) {
      vesselListSetting.columns.forEach(columnId => {
        const columnDef = initialColumnDefs.find(
          columnDef => columnDef.field === columnId
        );
        if (columnDef) {
          columnDefs.push(columnDef);
        }
      });
    } else {
      columnDefs = initialColumnDefs;
    }
    this.columnDefs = columnDefs;
    this.pageSize =
      vesselListSetting && vesselListSetting.page_size
        ? vesselListSetting.page_size
        : INITIAL_PAGE_SIZE;
    this.$nextTick(async () => {
      this.restoreSearchCondition(vesselListSetting);
      //this.gridApi.sizeColumnsToFit();

      await this.fetchCountryCode();
      this.searchVessels();
    });
  },
  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }
    let self = this;
    window.onresize = function() {
      self.gridApi.sizeColumnsToFit();
    };
  },
  beforeDestroy() {
    this.cleanup();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
};
</script>

<style lang="scss">
#page-vessel-list {
  .vx-input-group .prepend-text.btn-addon .vs-button {
    padding-top: -10px !important;
  }

  .vs-input-primary {
    width: 400px;
  }
  .vessel-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
  .ag-grid-table {
    height: calc(100% - 120px);
  }
  .ag-grid-cell-chip {
    border-radius: 5px;
    &.vs-chip-success {
      background: rgba(var(--vs-success), 0.15);
      color: rgba(var(--vs-success), 1) !important;
      font-weight: 500;
    }
    &.vs-chip-warning {
      background: rgba(var(--vs-warning), 0.15);
      color: rgba(var(--vs-warning), 1) !important;
      font-weight: 500;
    }
    &.vs-chip-danger {
      background: rgba(var(--vs-danger), 0.15);
      color: rgba(var(--vs-danger), 1) !important;
      font-weight: 500;
    }
  }
  .card-vessel-list {
    height: calc(100vh - 120px);
  }
}
</style>
